import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Intercom from 'components/Intercom';

// Utils.
import { isWebviewApp } from 'utils';

// Styles.
import './styles.module.scss';

export default class IntercomChat extends PureComponent {

  static propTypes = {
    isFetchedProfile: PropTypes.bool.isRequired,
    profile: PropTypes.object.isRequired,
    consents: PropTypes.object.isRequired,
    isFetchedConfig: PropTypes.bool.isRequired,
    isFetchedConsents: PropTypes.bool.isRequired,
    config: PropTypes.object.isRequired,
    locationPath: PropTypes.string.isRequired,
  };

  render() {
    // Don't show Intercom chart in measure-details page.
    if (/data-sources-mobile-back/.test(this.props.locationPath) === true) {
      return null;
    }
    if (/measure-details/.test(this.props.locationPath) === true) {
      return null;
    }
    if (/payment-cancel/.test(this.props.locationPath) === true) {
      return null;
    }
    const { auth, isFetchedProfile, isFetchedConsents, profile, isFetchedConfig, config, consents } = this.props;
    // Don't show Intercom chat if the web dasboard is opened from mobile app.
    if (isWebviewApp()) {
      return null;
    }
    if (!isFetchedProfile || !isFetchedConfig || !isFetchedConsents) {
      return null;
    }
    if (!config.intercom_key) {
      return null;
    }
    if (auth.userType !== 'full') {
      return null;
    }

    const functionalConsent = consents.find((consent) => consent.consent_type === 'cookie_functionality');

    if (functionalConsent?.consent_status !== 'granted') {
      return null;
    }
    const user = {
      user_id: profile.id,
      email: profile.email,
      name: profile.username,
      user_hash: profile.hmac,
    };
    return <Intercom appID={config.intercom_key} {...user} auth={auth} />;
  }

}
